angular
    .module('quattro.bmbo.domain.create-form', [
        'quattro.core.hpls_api_1',
        'quattro.core.hpls-api-validation',
        'quattro.core.password-form',
        'quattro.core.user.service',
        'quattro.bmbo.account.select-context',
    ])
    .directive('bmboDomainCreateForm', function () {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                cancel: '=',
                // will be called after successfull validation
                save: '=',
                error218: '=error218',
            },
            controller: 'bmboDomainCreateFormController',
            controllerAs: 'vm',
            templateUrl: 'bmbo/domain/domain-create-form.html',
        };
    })
    .controller('bmboDomainCreateFormController', function ($scope, userService, api, alertService) {

        var account = userService.get('userName');

        this.user = userService.scope;
        this.verified = false;
        this.verificationHost = '';
        this.verificationKey = '';
        this.validateSpfValid = true;
        this.validateSpfShould = '';
        this.validateSpfIs = '';

        // set context_id to first from list, VQ-618
        api.single({
            method: 'context.list',
            params: {
                account: account,
            }
        })
            .then(function (result) {
                $scope.data.context_id = Object.keys(result).shift() || 'new';
            });

        this.handleVerificationWin = function handleVerificationWin() {
            this.verified = true;
            this.verificationHost = '';
            this.verificationKey = '';
        };

        this.handleVerificationFail = function handleVerificationFail(reason) {
            this.verified = false;
            var data = reason.data;
            this.verificationHost = data.host;
            this.verificationKey = data.txt;
        };

        this.handleValidateSpf = function handleValidateSpf(response) {
            this.validateSpfValid = response.valid;
            this.validateSpfShould = response.spf_should;
            this.validateSpfIs = response.spf_is ? response.spf_is : '';
        }

        this.handleValidateSpfError = function handleValidateSpfError(response) {
            alertService.add('error', 'Domain SPF-Records konnten nicht geprüft werden.');
        }

        this.checkKeyAndSpf = function () {

            var domain = $scope.data.domain;

            if (!domain) {
                return;
            }

            api
                .single({
                    method: 'ownerverification.get',
                    params: {
                        entitytype: 'domain',
                        entity: domain,
                        verificationmethod: 'dns-txt-record',
                        account: account,
                    }
                }).then(
                this.handleVerificationWin.bind(this),
                this.handleVerificationFail.bind(this)
            );

            api
                .single({
                    method: 'domain.validate.spf',
                    params: {
                        domain: domain,
                    }
                }).then(
                this.handleValidateSpf.bind(this),
                this.handleValidateSpfError.bind(this)
            );
        };
    });
